var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/kb/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal"], function (require, exports, Common, Portal) {
    "use strict";
    var KBViewModel = (function (_super) {
        __extends(KBViewModel, _super);
        function KBViewModel() {
            _super.call(this);
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.knowledgeBaseUrl = 'https://wkuktaa.secure.force.com/knowledgebase/pkb_Home?l=en_US&c=TAA%3ACCH_OneClick';
            this.title = "knowledgeBase";
            ko.track(this, ["knowledgeBaseUrl"]);
        }
        KBViewModel.prototype.onActivated = function (context) {
        };
        return KBViewModel;
    }(Common.ViewModelBase));
    var instance = new KBViewModel();
    return instance;
});

